const metadata = ["Facebook", "Instagram", "LinkedIn", "Youtube", "Twitter"];

module.exports = { metadata };
